/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-get, ember/no-runloop, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Extends from
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
// Ember Imports
import { action, computed } from '@ember/object';
import { cancel, later } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import moment from 'moment';
import { classNames, tagName } from '@ember-decorators/component';

@tagName('span')
@classNames('layout-row', 'layout-xs-column')
export default class QuickAttendance extends Component {
  @service
  dates;

  @service
  store;

  @tracked now = moment();

  @computed('dates.currentTimetableDay.periods.[]', 'now')
  get periods() {
    let periods = this.get('dates.currentTimetableDay.periods');

    // If we have two or fewer periods, just show them all.
    if (isEmpty(periods) || periods.length <= 2) {
      return periods;
    }

    // Determine the 2 most recent periods.
    let startedPeriods = periods.filter((period) => {
      return this.now.isSameOrAfter(
        moment(period.startTime, 'HH:mm'),
        'minute',
      );
    });

    // If we haven't had 2 periods yet, show the first 2 periods.
    if (startedPeriods.length < 2) {
      return periods.slice(0, 2);
    }

    // Otherwise, return the 2 most recent periods.
    return startedPeriods.slice(-2);
  }

  person = null;
  @tracked records = null;
  @tracked
  timer = null;

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    this.records = [];
    this.now = moment();

    if (!isEmpty(this.person)) {
      this.store
        .query('attendance/record', {
          personId: this.person.id,
          dateId: this.dates.today.id,
        })
        .then((records) => {
          if (!this.isDestroying && !this.isDestroyed) {
            this.records = records;
          }
        });
    }

    this.scheduleUpdate();
  }

  willDestroy() {
    // Cancel any pending timer.
    if (!isEmpty(this.timer)) {
      cancel(this.timer);
    }

    return super.willDestroy(...arguments);
  }

  scheduleUpdate() {
    // Cancel any pending timer.
    if (!isEmpty(this.timer)) {
      cancel(this.timer);
    }

    // Default interval is 10 minutes.
    let interval = moment.duration(10, 'minutes').asMilliseconds();

    // If the current period ends prior to that, schedule the refresh for just
    // after the rollover (to trigger the displayed periods to change).
    let currentPeriod = this.get('dates.currentPeriod');
    if (!isEmpty(currentPeriod)) {
      let diff = moment().diff(moment(currentPeriod.endTime, 'HH:mm'));
      if (diff > 0 && diff < interval) {
        interval = diff + moment.duration(1, 'minute').asMilliseconds();
      }
    }

    // Schedule the update and store a reference to the timer.
    this.timer = later(this, 'update', interval);
  }

  update() {
    this.now = moment();
    if (this.records) {
      this.records.update();
    }
    this.scheduleUpdate();
  }

  @action
  updateRecords() {
    this.records.update();
  }
}
